import { FiltroDeclaracionJurada } from "../models/filtroDeclaracionJurada";
import { Suspense, useEffect } from "react";
import { selectorTransversal } from "../../../../dtos/selector";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { Grid2 } from "@mui/material";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { FilterList } from "@mui/icons-material";

interface IProps {
    onSubmit: (e: FiltroDeclaracionJurada) => void;
}

export const FormularioDeclaracionJurada = ({onSubmit} : IProps) => {

    const certificadosDisponibles : selectorTransversal[] = [
        {label: "Certificado 1896", value: "1896"},
        {label: "Certificado 1898", value: "1898"}
    ];

    const opcionesCertificar : selectorTransversal[] = [
        {label: "Activación", value: "O"},
        {label: "Rectificación", value: "R"}
    ];

    const anioMax = new Date().getFullYear();

    const schema = Yup.object<FiltroDeclaracionJurada>().shape({
        anioComercial: Yup.number().required("Campo requerido").max(anioMax, "El año comercial no puede superar el año actual"),
        tipoCertificado: Yup.string().required("Campo requerido"),
        tipo: Yup.string().required("Campo requerido"),
        numeroFolio: Yup.number().nullable().optional(),
    });

    const {
        control,
        formState: { errors, isDirty },
        reset,
        watch,
        handleSubmit,
        setError,
        setValue,
    } = useForm<FiltroDeclaracionJurada>({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    useEffect(() => {
        setValue("anioComercial", anioMax - 1)
        setValue("tipoCertificado", "1896")
        setValue("tipo", "O")
    }, [])

    const prepareOnSubmit = (e: FiltroDeclaracionJurada) => {
        if (e.tipo === "O" && !e.numeroFolio){
            setError("numeroFolio", { type: 'manual', message: 'En una operación de "Activacion" debe indicar un numero de folio' })
            return;
        }
        else if (!e.numeroFolio){
            e.numeroFolio = 0;
        }
        onSubmit(e);
    }

    return (
        <Suspense>
            <form onSubmit={handleSubmit(prepareOnSubmit)}>
                <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            name={"anioComercial"}
                            control={control}
                            decimales={0}
                            label="Año"
                            error={errors.anioComercial}
                            minValue={0}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label="Tipo de certificado"
                            name={'tipoCertificado'}
                            control={control}
                            options={certificadosDisponibles}
                            error={errors.tipoCertificado}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label="Tipo"
                            name={'tipo'}
                            control={control}
                            options={opcionesCertificar}
                            error={errors.tipo}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            name={"numeroFolio"}
                            control={control}
                            label="N° folio"
                            error={errors.numeroFolio}
                        />
                    </Grid2>
                </Grid2> 
                <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                        Generar
                    </MButton>
                </Grid2>
            </form>
        </Suspense>
    )
}